import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

export const mapSettingsDataLayersInstancesSelector = (state: AppState) => state.map.mapSettings.data.dataLayers.instances;
export const useMapSettingsDataLayersInstancesSelector = () => useSelector(mapSettingsDataLayersInstancesSelector);

export const mapSettingsActiveDataLayerSelector = (state: AppState) => {
  const instances = mapSettingsDataLayersInstancesSelector(state);
  // for now we support only one active data layer at a time
  return instances.length > 0 ? instances[0] || null : null;
};
export const useMapSettingsActiveDataLayerSelector = () => useSelector(mapSettingsActiveDataLayerSelector);

export const mapSettingsBoundaryGroupsPerDataLayersSelector = (state: AppState) => state.map.mapSettings.data.dataLayers.boundaryGroup;
export const useMapSettingsBoundaryGroupsPerDataLayersSelector = () => useSelector(mapSettingsBoundaryGroupsPerDataLayersSelector);

export const mapSettingsDataLayersPrimaryBoundaryGroupIdSelector = (state: AppState) => {
  const activeDataLayer = mapSettingsActiveDataLayerSelector(state);
  const boundaryGroupsPerDataLayers = mapSettingsBoundaryGroupsPerDataLayersSelector(state);

  if (activeDataLayer && boundaryGroupsPerDataLayers[activeDataLayer.id]) {
    return boundaryGroupsPerDataLayers[activeDataLayer.id];
  }

  return null;
};
